import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {SEARCH_STATE_NAME} from '../constant';

interface SearchSliceState {
  searchKeyword: string;
  openAutoComplete: boolean;
  openPcSearchModal: boolean;
  openSearchDialog: boolean;
}

export const searchSlice = createSlice({
  name: SEARCH_STATE_NAME,
  initialState: {
    searchKeyword: '',
    openAutoComplete: false,
    openPcSearchModal: false,
    openSearchDialog: false,
  } as SearchSliceState,
  reducers: {
    setOpenAutoComplete: (state, action: PayloadAction<boolean>) => {
      state.openAutoComplete = action.payload;
    },
    setSearchkeyword: (state, action: PayloadAction<string>) => {
      state.searchKeyword = action.payload;
    },
    setOpenPcSearchModal: (state, action: PayloadAction<boolean>) => {
      state.openPcSearchModal = action.payload;
    },
    setOpenSearchDialog: (state, action: PayloadAction<boolean>) => {
      state.openSearchDialog = action.payload;
    },
  },
});

export const {
  setOpenAutoComplete,
  setSearchkeyword,
  setOpenPcSearchModal,
  setOpenSearchDialog,
} = searchSlice.actions;
